<template>
  <div dusk="contrato-verificar">
    <vs-button
      id="contrato-verificar-abrir"
      class="font-semibold"
      type="gradient"
      color="#7367F0"
      gradient-color-secondary="#CE9FFC"
      @click="sideBarVisible = true"
    >
      <span class="inline-block align-middle mr-3">
        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
      </span>
      Novo contrato
    </vs-button>

    <vs-sidebar
      id="contrato-verificar"
      class="add-new-data-sidebar items-no-padding vs-con-loading__container"
      click-not-close
      position-right
      parent="body"
      default-index="1"
      color="primary"
      spacer
      v-model="sideBarVisible"
    >
      <div class="mt-6 flex items-center justify-between px-6">
        <h4>VERIFICAR CONTRATO</h4>
        <feather-icon
          icon="XIcon"
          @click.stop="sideBarVisible = false"
          class="cursor-pointer"
        ></feather-icon>
      </div>

      <vs-divider class="mb-0"></vs-divider>

      <VuePerfectScrollbar
        class="scroll-area--data-list-add-new pt-4 pb-6"
        :settings="settings"
      >
        <div class="p-6" v-if="sideBarVisible">
          <div class="mb-4" v-if="todasAsAssociacoes">
            <div>Associação:</div>
            <associacao-select
              v-model="form.associacao"
              name="associacao"
              v-validate="'required'"
            ></associacao-select>
            <span
              class="text-danger text-sm"
              v-show="errors.has('associacao')"
              >{{ errors.first("associacao") }}</span
            >
          </div>

          <div class="mb-4">
            <span>CPF:</span>
            <cpf-input
              v-validate="'required|cpf'"
              class="w-full"
              name="cpf"
              v-model="form.cpf"
              autocomplete="off"
              :enterEvent="adicionar"
            ></cpf-input>
            <span class="text-danger text-sm" v-show="errors.has('cpf')">{{
              errors.first("cpf")
            }}</span>
          </div>

          <div class="mb-4">
            <span>Número do Benefício:</span>
            <number-input
              v-validate="'required'"
              class="w-full"
              name="beneficio"
              autocomplete="off"
              v-model="form.beneficio"
              :enterEvent="adicionar"
            ></number-input>
            <span
              class="text-danger text-sm"
              v-show="errors.has('beneficio')"
              >{{ errors.first("beneficio") }}</span
            >
          </div>

          <div class="mb-4 flex justify-between">
            <div>
              <span class="mr-1 inline-block align-middle"
                >Tipo de desconto</span
              >
              <vs-tooltip
                text="Selecione aqui como você gostaria fazer as cobranças deste cliente."
                class="inline-block"
              >
                <vs-icon class="align-middle" icon="help_outline"></vs-icon
                >&nbsp;
              </vs-tooltip>
            </div>

            <vs-dropdown vs-trigger-click>
              <a class="a-icon" href.prevent>
                {{ formaPagamentoNome }}
                <vs-icon class icon="expand_more"></vs-icon>
              </a>

              <vs-dropdown-menu>
                <template v-for="(forma, index) in formasPagamento">
                  <vs-dropdown-item
                    :key="index"
                    :disabled="formaPagamentoDisabled(forma)"
                    @click="form.formaPagamento = forma"
                    >{{ forma.nome }}</vs-dropdown-item
                  >
                </template>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>

          <div class="mb-4 flex justify-between">
            <div>
              <span class="mr-1 inline-block align-middle">Tipo de venda</span>

              <vs-tooltip
                text="Nos informe se o cliente está presente no local no momento da venda."
                class="inline-block"
              >
                <vs-icon class="align-middle" icon="help_outline"></vs-icon
                >&nbsp;
              </vs-tooltip>
            </div>
            <div>
              <vs-dropdown vs-trigger-click>
                <a class="a-icon" href.prevent>
                  {{ tipoContratoNome }}
                  <vs-icon class icon="expand_more"></vs-icon>
                </a>

                <vs-dropdown-menu>
                  <template v-for="(tipo, index) in tiposContrato">
                    <vs-dropdown-item
                      :key="index"
                      :disabled="tipoContratoDisabled(tipo)"
                      @click="form.tipoContrato = tipo"
                      >{{ tipo.nome }}</vs-dropdown-item
                    >
                  </template>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </div>
        </div>
      </VuePerfectScrollbar>

      <div class="flex flex-wrap items-center justify-center p-6" slot="footer">
        <vs-button
          type="border"
          class="mr-6"
          color="danger"
          @click="sideBarVisible = false"
          >Cancelar</vs-button
        >
        <vs-button
          id="contrato-verificar-submit"
          type="border"
          @click="adicionar"
          >Próximo</vs-button
        >
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import AssociacaoSelect from "@components/select/AssociacaoSelect.vue";
import CpfInput from "@/components/inputs/CpfInput.vue";
import NumberInput from "@/components/inputs/NumberInput.vue";
import api from "@services/api-service";

export default {
  components: {
    AssociacaoSelect,
    VuePerfectScrollbar,
    NumberInput,
    CpfInput
  },
  data() {
    return {
      sideBarVisible: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      form: {
        associacao: null,
        formaPagamento: null,
        tipoContrato: null,
        cpf: "",
        beneficio: ""
      }
    };
  },
  created() {
    this.$store.dispatch("FETCH_FORMA_PAGAMENTO");
    this.$store.dispatch("FETCH_TIPO_CONTRATO");

    this.resetForm();
  },
  beforeDestroy() {
    this.sideBarVisible = false;
  },
  computed: {
    formaPagamentoNome() {
      return this.form.formaPagamento
        ? this.form.formaPagamento.nome
        : this.formaPagamentoDescontoEmFolha.nome;
    },
    tipoContratoNome() {
      return this.form.tipoContrato
        ? this.form.tipoContrato.nome
        : this.tipoContratoPadrao.nome;
    },
    formasPagamento() {
      return this.$store.getters.getFormasPagamento();
    },
    tiposContrato() {
      return this.$store.getters.getTiposContrato();
    },
    formaPagamentoDescontoEmFolha() {
      return this.$store.getters.getFormaPagamentoDescontoEmFolha();
    },
    tipoContratoPadrao() {
      return this.$store.getters.getTipoContratoPadrao();
    }
  },
  watch: {
    value(value) {
      this.model = value;
    },
    sideBarVisible(visible) {
      if (!visible) this.$nextTick(() => this.resetForm());
    }
  },
  methods: {
    async adicionar() {
      const formValido = await this.$validator.validateAll();

      if (!formValido) return;

      this.$vs.loading({
        background: "primary",
        color: "#fff",
        container: "#contrato-verificar-submit",
        scale: 0.45
      });

      if (!this.form.formaPagamento) {
        this.form.formaPagamento = this.formaPagamentoDescontoEmFolha;
      }

      if (!this.form.tipoContrato) {
        this.form.tipoContrato = this.tipoContratoPadrao;
      }

      api()
        .post(`contratos/verificar-beneficio`, {
          beneficio: this.form.beneficio,
          forma_pagamento_id: this.form.formaPagamento.id,
          tipo_contrato_id: this.form.tipoContrato.id,
          associacao_id: this.form.associacao.id
        })
        .then(response => {
          if (response.data.status === true) throw Error();

          this.sideBarVisible = false;
          this.$vs.notify({
            title: "Sucesso!",
            text: "Para cadastrar o contrato, preencha os dados a seguir.",
            color: "success",
            iconPack: "feather",
            icon: "icon-check",
            position: "bottom-center"
          });
          this.$nextTick(() =>
            this.$router.push({
              name: "cadastrar-contrato",
              params: {
                cpf: this.form.cpf,
                beneficio: this.form.beneficio,
                associacao: this.form.associacao,
                tipoContrato: this.form.tipoContrato,
                tiposContrato: this.tiposContrato,
                formaPagamento: this.form.formaPagamento
              }
            })
          );
        })
        .catch(() => {
          this.$vs.notify({
            title: "Não Disponível",
            text: "O benefício informado já possui descontos no sistema",
            color: "danger",
            iconPack: "feather",
            icon: "icon-alert-circle",
            position: "bottom-center"
          });
        })
        .finally(() =>
          this.$vs.loading.close("#contrato-verificar-submit > .con-vs-loading")
        );
    },
    formaPagamentoDisabled(formaPagamento) {
      if (this.form.formaPagamento) {
        return this.form.formaPagamento.id === formaPagamento.id;
      }
      return this.formaPagamentoDescontoEmFolha.id === formaPagamento.id;
    },
    tipoContratoDisabled(tipo) {
      if (this.form.tipoContrato) {
        return this.form.tipoContrato.id === tipo.id;
      }
      return this.tipoContratoPadrao.id === tipo.id;
    },
    resetForm() {
      this.form = {
        associacao: this.$store.getters.getUsuarioAssociacao(),
        formaPagamento: this.$store.getters.getFormaPagamentoDescontoEmFolha(),
        tipoContrato: this.$store.getters.getTipoContratoPadrao(),
        beneficio: ""
      };

      this.$validator.reset();
    }
  }
};
</script>
